import React from 'react';
import {useTranslation} from 'react-i18next';

import {UserMenuDropContent} from '@pexip/components';

import styles from './TopUserMenuDropContent.module.scss';

export const TopUserMenuDropContent: React.FC<
    React.ComponentProps<typeof UserMenuDropContent>
> = props => {
    const {t, i18n} = useTranslation();
    const dir = i18n.dir(i18n.language);

    return (
        <UserMenuDropContent
            position={dir === 'rtl' ? 'bottomLeft' : 'bottomRight'}
            tooltipPosition={dir === 'rtl' ? 'bottomStart' : 'bottomEnd'}
            modifier="square"
            variant="translucent"
            title={t('settings.menu-button-tooltip', 'Settings')}
            buttonLabel={t(
                'settings.menu-button-label',
                'Toggle settings menu',
            )}
            contentClassName={styles.content}
            {...props}
        />
    );
};
